import { render, staticRenderFns } from "./localsMix.vue?vue&type=template&id=60aedf14"
import script from "./localsMix.vue?vue&type=script&lang=js"
export * from "./localsMix.vue?vue&type=script&lang=js"
import style0 from "./localsMix.vue?vue&type=style&index=0&id=60aedf14&prod&lang=scss&scope=true"
import style1 from "./localsMix.vue?vue&type=style&index=1&id=60aedf14&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports